import fetch from './../fetch';

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100, }) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}');
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('academicGuidanceAnalysis/salaryByOrg', Object.assign(defaultsParams, keywords))
    .then(response => {
        return {
            data: response.payload.data,
            meta: response.payload.meta.extParams
        };
    });
}


export default {
    querySearch,
}